"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Sun = _interopRequireDefault(require("./Sun"));

var _Cloudy = _interopRequireDefault(require("./Cloudy"));

var _Rain = _interopRequireDefault(require("./Rain"));

var _Snow = _interopRequireDefault(require("./Snow"));

var _Wind = _interopRequireDefault(require("./Wind"));

var _CloudyNight = _interopRequireDefault(require("./CloudyNight"));

var _Moon = _interopRequireDefault(require("./Moon"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var props = {
  transform: 'translate(-12, 35)'
};

var NightWrap = _styled["default"].g(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transform: translate(5px, 4px);\n"]))); // This component is meant to be used wihin an SVG only
// Darksky icon options
// clear-day
// clear-night
// rain
// snow
// sleet
// wind
// fog
// cloudy
// partly-cloudy-day
// partly-cloudy-night
// hail
// thunderstorm
// tornado


var ChartTick = function ChartTick(_ref) {
  var label = _ref.label,
      icon = _ref.icon,
      fontSize = _ref.fontSize,
      fill = _ref.fill;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon === 'clear-day' && /*#__PURE__*/_react["default"].createElement(_Sun["default"], _extends({
    fill: fill
  }, props)), (icon === 'partly-cloudy-day' || icon === 'cloudy' || icon === 'fog') && /*#__PURE__*/_react["default"].createElement(_Cloudy["default"], _extends({
    fill: fill
  }, props)), icon === 'rain' && /*#__PURE__*/_react["default"].createElement(_Rain["default"], _extends({
    fill: fill
  }, props)), (icon === 'snow' || icon === 'sleet') && /*#__PURE__*/_react["default"].createElement(_Snow["default"], _extends({
    fill: fill
  }, props)), icon === 'wind' && /*#__PURE__*/_react["default"].createElement(_Wind["default"], _extends({
    fill: fill
  }, props)), icon === 'partly-cloudy-night' && /*#__PURE__*/_react["default"].createElement(NightWrap, null, /*#__PURE__*/_react["default"].createElement(_CloudyNight["default"], _extends({
    fill: fill
  }, props))), icon === 'clear-night' && /*#__PURE__*/_react["default"].createElement(NightWrap, null, /*#__PURE__*/_react["default"].createElement(_Moon["default"], _extends({
    fill: fill
  }, props))), /*#__PURE__*/_react["default"].createElement("text", {
    textAnchor: "middle",
    dy: "0.72em",
    transform: "translate(0, 14)",
    style: {
      fontSize: fontSize
    }
  }, label));
};

ChartTick.propTypes = {
  icon: _propTypes["default"].string,
  label: _propTypes["default"].string,
  fontSize: _propTypes["default"].string,
  fill: _propTypes["default"].string
};
ChartTick.defaultProps = {
  icon: null,
  label: null,
  fill: '#B2ADA6',
  fontSize: '14px'
};
var _default = ChartTick;
exports["default"] = _default;